/**
 * @module ui/templates/election/key-riding
 */

import tgamConfig from "config/tgam";

/**
 * Key riding card
 * @param {Object} data - Data object
 * @param {String} data.label - The name of the riding
 * @param {String} data.description - A description of the riding
 * @param {String} data.byline - An author byline
 * @returns {String} HTML markup representing a key riding card
 */
export default function keyRidingTemplate({ label, description, byline }) {
  const keyRidingLabel = label ? label : "Riding to watch";
  return `
    <div class="c-election-key-riding">
      <div class="c-indicator-icon c-election-key-riding__indicator-icon">
        <svg class="c-indicator-icon__art" role="img" pointer-events="none" focusable="false" aria-hidden="true">
         <use xlink:href="${tgamConfig.env.svgSpritePath}#icon-star"></use>
        </svg>
        <span class="c-election-key-riding__indicator-icon-screenreader-text u-visually-hidden">Key Riding</span>
      </div>
      <h2 class="c-election-key-riding__title">${keyRidingLabel}</h2>
      <div class="c-election-key-riding__body">
        ${description ? `<p class="c-election-key-riding__description">${description}</p>` : ""}
        ${byline ? `<div class="c-election-key-riding__byline">${byline}</div>` : ""}
      </div>
    </div>
  `;
}
